import { useAuthAPI } from '../../common/hooks/useAuthAPI';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { CACHEDFILEKEYS } from '.';
import { imagesExt } from '../FilePreview';
const FileKeyLoaderMultiFetchContext = /*#__PURE__*/createContext({
  loading: false
});
export const useFileKeyLoaderMultiFetch = () => {
  return useContext(FileKeyLoaderMultiFetchContext);
};

const MultiFetch = ({
  fileKeys,
  queryKey,
  endpoint,
  payload,
  managePayload,
  cache,
  cacheExpiration,
  cacheUniqueString,
  cacheUniqueStrings,
  isSureImage,
  children
}) => {
  const [loading, setLoading] = useState(true);
  const request = useAuthAPI(endpoint);
  useEffect(() => {
    if (fileKeys && fileKeys.length > 0) {
      let images = [];

      const callback = uniqueString => {
        fileKeys.forEach(fileKey => {
          const cacheKey = fileKey + uniqueString;

          if (cacheKey in CACHEDFILEKEYS && !!cacheExpiration) {
            const currentInterval = Date.now() - CACHEDFILEKEYS[cacheKey].timeStamp;

            if (currentInterval > cacheExpiration) {
              delete CACHEDFILEKEYS[cacheKey];
            }
          }
        });
        return fileKeys.filter(fileKey => {
          const isImage = isSureImage || imagesExt.includes(fileKey.split('.').pop() || "not-image");
          const cacheKey = fileKey + uniqueString;
          return !(cacheKey in CACHEDFILEKEYS) && fileKey && isImage;
        }).map(fileKey => {
          return {
            "fileKey": fileKey,
            "thumbnail": fileKey.includes('upload'),
            ...payload,
            ...(managePayload && managePayload(uniqueString))
          };
        });
      };

      if (Array.isArray(cacheUniqueStrings) && cacheUniqueStrings.length > 0) {
        images = cacheUniqueStrings.map(callback).flat();
      } else {
        images = callback(cacheUniqueString);
      }

      if (images.length > 0) {
        setLoading(true);
        request.call({
          data: {
            images
          }
        }).then(response => {
          const data = response.data[queryKey];

          if (data && data.length > 0 && cache) {
            data.forEach(item => {
              const cacheKey = item.fileKey + cacheUniqueString;
              CACHEDFILEKEYS[cacheKey] = {
                url: item.url || 'not-image',
                timeStamp: Date.now()
              };
            });
          }
        }).finally(() => {
          setLoading(false);
        });
      }
    }
  }, [fileKeys]);
  return /*#__PURE__*/React.createElement(FileKeyLoaderMultiFetchContext.Provider, {
    value: {
      loading
    }
  }, children);
};

MultiFetch.defaultProps = {
  endpoint: '/api/FileImage/multiple',
  queryKey: 'urLs'
};
export default MultiFetch;